import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { ActivationRedirectService } from '../../activation-redirect/activation-redirect.service';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { TranslationService } from '../../shared/translation.service';
import { interpolateLinks } from '../../shared/helpers/interpolate-links';
import { resolveProductCategoryKey } from '../../shared/helpers/resolve-product-category-key';

@Component({
  selector: 'lp2-progress-test-banner',
  template: `
    <div class="banner" role="region" aria-label="Progress test">
      <div class="right-container">
        <p class="title">{{ 'oeapp.placement.progressResetBanner.title' | translate }}</p>
        <p *ngIf="pdfUrl; else plainBody" class="body" [innerHTML]="bodyWithLinkHtml"></p>
        <ng-template #plainBody>
          <p class="body">{{ 'oeapp.placement.progressResetBanner.body' | translate }}</p>
        </ng-template>
      </div>
      <button type="button" (click)="startProgressTest()" class="cta">
        {{ 'oeapp.placement.progressResetBanner.cta' | translate }}
      </button>
    </div>
  `,
  styleUrls: ['./progress-test-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressTestBannerComponent {
  @HostBinding('class') hostClass = 'container';

  constructor(
    private readonly activationRedirectService: ActivationRedirectService,
    private readonly oeAppPersonService: OeAppPersonService,
    private readonly translationService: TranslationService
  ) {}

  public get pdfUrl(): string | null {
    const key = resolveProductCategoryKey(
      (k) => this.translationService.translate(k),
      this.oeAppPersonService.productCategory,
      'oeapp.placement.progressResetBanner.pdfUrl'
    );
    const translated = this.translationService.translate(key);
    return translated === key ? null : translated;
  }

  public get bodyWithLinkHtml(): string {
    const translated = this.translationService.translate('oeapp.placement.progressResetBanner.bodyWithLink');
    const url = this.pdfUrl;
    return url ? interpolateLinks(translated, [url]) : translated;
  }

  public startProgressTest() {
    this.activationRedirectService.redirectToProgressTest();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/progress-test-banner/progress-test-banner.component.ts